import { render } from "./AuditsPanel.vue?vue&type=template&id=5ac3147a&scoped=true"
import script from "./AuditsPanel.vue?vue&type=script&lang=js"
export * from "./AuditsPanel.vue?vue&type=script&lang=js"

import "./AuditsPanel.vue?vue&type=style&index=0&id=5ac3147a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac3147a"]])

export default __exports__